import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "menu", "option"]

  connect() {
    this._onOutsideClick = (e) => {
      if (!this.element.contains(e.target)) this.close()
    }
    this._onBeforeCache = () => this.close()
    document.addEventListener("turbo:before-cache", this._onBeforeCache)
  }

  disconnect() {
    document.removeEventListener("click", this._onOutsideClick)
    document.removeEventListener("turbo:before-cache", this._onBeforeCache)
  }

  open() {
    if (this.menuTarget.classList.contains("show")) return
    this._filter(this.inputTarget.value)
    this.menuTarget.classList.add("show")
    document.addEventListener("click", this._onOutsideClick)
  }

  close() {
    this.menuTarget.classList.remove("show")
    document.removeEventListener("click", this._onOutsideClick)
  }

  filter() {
    this._filter(this.inputTarget.value)
    if (!this.menuTarget.classList.contains("show")) this.open()
  }

  select(event) {
    this.inputTarget.value = event.currentTarget.dataset.value
    this.inputTarget.focus()
    this.close()
  }

  _filter(query) {
    const q = query.toLowerCase()
    this.optionTargets.forEach(btn => {
      btn.closest("li").hidden = !btn.dataset.value.toLowerCase().includes(q)
    })
  }
}
